import { Observable } from 'rxjs';

import {
	AudioChannelFeatureUpdateInput,
	PassiveSpeakerFeatureUpdateInput
} from '@shure/shared/angular/data-access/system-api/core';

export abstract class AudioChannelCoreApiService {
	public abstract setAudioChannelIdentify(channelId: string, identifying: boolean): Observable<void>;

	public abstract updateAudioChannel(channelId: string, inputs: AudioChannelFeatureUpdateInput[]): Observable<void>;
	public abstract updateAudioChannels(
		channelInputs: { channelId: string; inputs: AudioChannelFeatureUpdateInput[] }[]
	): Observable<void>;

	public abstract updateAudioPassiveSpeaker(
		passiveSpeakerId: string,
		inputs: PassiveSpeakerFeatureUpdateInput[]
	): Observable<void>;

	public abstract updateAudioPassiveSpeakers(
		passiveSpeakerInputs: { speakerId: string; inputs: PassiveSpeakerFeatureUpdateInput[] }[]
	): Observable<void>;
}
